export enum AUX_BAR_ITEM_ENUM {
    COMPONENT = 'component',
    SECTION = 'section',
    STYLE = 'style',
    PAGE_TREE = 'pageTree',
}

export const AUX_BAR_ITEM_KEY_MAP = {
    [AUX_BAR_ITEM_ENUM.COMPONENT]: AUX_BAR_ITEM_ENUM.COMPONENT,
    [AUX_BAR_ITEM_ENUM.SECTION]: AUX_BAR_ITEM_ENUM.SECTION,
    [AUX_BAR_ITEM_ENUM.STYLE]: AUX_BAR_ITEM_ENUM.STYLE,
    [AUX_BAR_ITEM_ENUM.PAGE_TREE]: AUX_BAR_ITEM_ENUM.PAGE_TREE,
} as const;

export enum SIDEBAR_UPPER_NAV_TAB_ENUM {
    // ui show card
    RICH_TEXT = 'richText',
    BUTTON = 'button',
    MEDIA = 'media',
    PRODUCT_LIST = 'productList',
    CAROUSEL = 'carousel',
    TOOLS = 'tools',
    PAGE_COMPONENT = 'pageComponent',

    // section show card
    TEXT_LAYOUT = 'textLayout',
    EXHIBIT = 'exhibit',
    IMG_WALL = 'imgWall',
    PAGE_SECTION = 'pageSection',
}
